import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Logo from '../icons/Logo';
import Button from './Button';

import styles from '../../../styles/buttons/home.module.scss';

const propTypes = {
    href: PropTypes.string,
    logoComponent: PropTypes.string,
    className: PropTypes.string,
    logoClassName: PropTypes.string,
    onClick: PropTypes.func,
};

const defaultProps = {
    href: null,
    logoComponent: null,
    className: null,
    logoClassName: null,
    onClick: null,
};

function LogoButton({ href, logoComponent, className, logoClassName, onClick }) {
    return (
        <Button
            className={classNames([styles.container, { [className]: className !== null }])}
            href={href}
            onClick={onClick}
        >
            {logoComponent !== null ? (
                <Logo
                    component={logoComponent}
                    className={classNames([
                        styles.logo,
                        { [logoClassName]: logoClassName !== null },
                    ])}
                />
            ) : null}
        </Button>
    );
}

LogoButton.propTypes = propTypes;
LogoButton.defaultProps = defaultProps;

export default LogoButton;
